import { render, staticRenderFns } from "./NearMatches.vue?vue&type=template&id=e910a48e&scoped=true&"
import script from "./NearMatches.vue?vue&type=script&lang=js&"
export * from "./NearMatches.vue?vue&type=script&lang=js&"
import style0 from "./NearMatches.vue?vue&type=style&index=0&id=e910a48e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e910a48e",
  null
  
)

export default component.exports